import { useTranslation } from "react-i18next";

import { type AreaWithSensorInfo, getIsOccupancyEnabled, useAppSelector } from "@lib/store";
import { Icon } from "@atoms";

import { OccupancyStatusIcon } from "./OccupancyStatusIcon";

// What the area's sensors say and when they last did. With occupancy on, an area without sensors says so.
export const AreaSensorStatus = ({ area }: { area: AreaWithSensorInfo }) => {
  const { t } = useTranslation();
  const isOccupancyEnabled = useAppSelector(getIsOccupancyEnabled);
  const { sensorInformation, sensorUpdateTimeLabel } = area;

  if (sensorInformation) {
    return (
      <div className="flex items-center gap-4">
        <OccupancyStatusIcon status={sensorInformation.status} />
        <div className="flex flex-col">
          <h4 className="text-[15px] font-semibold leading-5">{sensorInformation.title}</h4>
          {sensorUpdateTimeLabel && <p className="text-mapiq-black-500">{sensorUpdateTimeLabel}</p>}
        </div>
      </div>
    );
  }

  if (!isOccupancyEnabled) return null;

  return (
    <div className="flex items-center gap-4 text-mapiq-black-400">
      <Icon
        icon="noBroadcast"
        size="24px"
        color="currentColor"
      />
      <h4 className="text-[15px] font-semibold leading-5 text-mapiq-black-800*">
        {t("translation:NoSensorInstalled")}
      </h4>
    </div>
  );
};
